<template>
  <b-container style="width:600px;">
    <b-card>
      <h3>Process Enrollment</h3>
      <br/>
      <b-card-text>
        <b-input-group prepend="Token">
          <b-form-input autocomplete="off" v-model="form.token" @keyup.enter="getEnrollment"
                        type="text"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="getEnrollment">Submit
              <b-spinner v-if="this.isSending" class="m-1" label="Spinning" small/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <div v-if="token_errors.length" class="mt-3" style="color:red">
          <span v-for="error in token_errors" :key="error">{{ error }}</span>
        </div>

        <div v-if="enrollment" class="mt-3">
          <b>Enrollment:</b>
          <ul class="pl-0 pt-2" style="list-style: none">
            <li><span class="text-muted">Email:</span> {{ enrollment.email }}</li>
            <li>
              <span class="text-muted">Course:</span> <a :href="'/course/' + enrollment.lti_course.context_id">{{ enrollment.lti_course.context_title }}</a>
              <span v-b-tooltip.hover :title="new Date(enrollment.updated_at).toLocaleString()"
                    v-if="enrollment.is_processed"
                    class="ml-1 badge border border-muted text-success">p</span>
              <span v-b-tooltip.hover
                :title="(enrollment.coupons.length > 0 ? enrollment.coupons[0].coupon_code : enrollment.stripe_event_id ? 'stripe' : '')"
                v-if="enrollment.is_processed && (enrollment.coupons.length > 0 || enrollment.stripe_event_id)"
                class="ml-1 badge border border-secondary text-secondary">
                {{ enrollment.coupons.length > 0 ? 'coupon' : enrollment.stripe_event_id ? 'stripe' : '' }}
              </span>
            </li>
            <li><span class="text-muted">Platform:</span> {{enrollment.lti_course.canvas_domain}}</li>
            <li>
              <span class="text-muted">Type:</span> {{ enrollment.grade_passback_id ? 'LTI 1.1 (grade passback)' : 'Direct Join' }}
            </li>
          </ul>
          <div class="mb-0">
            <div v-if="!enrollment.is_processed">
              <b-button variant="success" @click="processEnrollment" size="sm">Process
                <b-spinner v-if="this.isProcessing" class="m-1" label="Spinning" small/>
              </b-button>
              <ul v-if="process_errors.length" class="mt-3 list-unstyled">
                <li v-for="error in process_errors" :key="error" style="color:red">{{ error }}</li>
              </ul>
              <div v-if="needs_credentials" class="mt-2">
                Student can complete enrollment at:<br/>
                <a :href="'/pay?token=' + form.token" target="_blank">{{ payUrl }}</a>
              </div>
            </div>
            <div v-if="enrollment.is_processed">
              <b-button variant="success" @click="unProcessEnrollment" size="sm">UnProcess
                <b-spinner v-if="this.isProcessing" class="m-1" label="Spinning" small/>
              </b-button>
            </div>
          </div>
        </div>

        <div v-if="membership" class="mt-3">
          <b>LTI 1.3 Enrollment:</b>
          <ul class="pl-0 pt-2">
            <li style="list-style: none">{{ membership.email }}</li>
            <li style="list-style: none">
              <!--<a :href="'/course/' + membership.context.context_id + '+' + membership.context.deployment.deployment_id">{{
                  membership.context.context_title
                }}</a>
                -->
              {{ membership.context.context_title }}
              <span v-b-tooltip.hover :title="new Date(membership.processed_at).toLocaleString()"
                    v-if="membership.processed_at"
                    class="badge border border-muted text-success">p</span>
              <span v-b-tooltip.hover :title="membership.role"
                    class="ml-1 badge border border-muted text-muted">{{ membership.role.charAt(0) }}</span>
                    <span v-b-tooltip.hover
                :title="(membership.coupon ? membership.coupon.coupon_code : membership.stripe_event_id ? 'stripe' : '')"
                v-if="membership.processed_at && (membership.coupon || membership.stripe_event_id)"
                class="ml-1 badge border border-secondary text-secondary">
                {{ membership.coupon ? 'coupon' : membership.stripe_event_id ? 'stripe' : '' }}
              </span>
            </li>
            <li style="list-style: none">
              <strong>School:</strong> {{ membership.context.deployment.credential.school_name || 'N/A' }}
            </li>
            <li style="list-style: none">
              <strong>Domain:</strong> {{ membership.context.deployment.credential.platform.iss.slice(8) }}
            </li>
          </ul>
          <ul class="p-0">
            <li style="list-style: none" v-if="!membership.processed_at">
              <b-button variant="success" @click="processMembership" size="sm">Process
                <b-spinner v-if="this.isProcessing" class="m-1" label="Spinning" small/>
              </b-button>
              <ul v-if="membership_errors.length" class="mt-3 list-unstyled">
                <li v-for="error in membership_errors" :key="error" style="color:red">{{ error }}</li>
              </ul>
            </li>
            <li style="list-style: none" v-if="membership.processed_at">
              <b-button variant="success" @click="unProcessMembership" size="sm">UnProcess
                <b-spinner v-if="this.isProcessing" class="m-1" label="Spinning" small/>
              </b-button>
            </li>
          </ul>
        </div>

      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
import {
  getEnrollment,
  getMembership,
  processEnrollment,
  processMembership,
  unProcessEnrollment,
  unProcessMembership
} from "../../utils/twa-api"
import {ERROR_MESSAGES} from "../../utils/error-messages"

export default {
  data() {
    return {
      form: {
        token: this.$route.query.token || this.$route.params.token
      },
      isSending: false,
      isProcessing: false,
      token_errors: [],
      process_errors: [],
      membership_errors: [],
      needs_credentials: false,
      enrollment: null,
      membership: null
    }
  },
  computed: {
    payUrl() {
      return window.location.origin + '/pay?token=' + this.form.token
    }
  },
  methods: {
    handleLoginEvent(data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    },
    async getEnrollment() {
      this.isSending = true
      this.enrollment = null
      this.membership = null
      this.token_errors = []
      this.process_errors = []
      this.membership_errors = []
      this.needs_credentials = false

      try {
        this.enrollment = await getEnrollment(this.form.token)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // do nothing - try membership next
        } else if (error.response && error.response.status === 500) {
          this.token_errors.push("Internal Server Error");
        } else if (!error.response) {
          this.token_errors.push("Network error");
        }
      }

      if (!this.enrollment && this.token_errors.length === 0) {
        try {
          this.membership = await getMembership(this.form.token)
        } catch (error) {
          if (error.response && error.response.status === 404) {
            this.token_errors.push("Enrollment or Membership not found");
          } else if (error.response && error.response.status === 500) {
            this.token_errors.push("Internal Server Error");
          } else if (!error.response) {
            this.token_errors.push("Network error");
          }
        }
      }
      this.isSending = false
    },
    async processEnrollment() {
      this.isProcessing = true
      this.process_errors = []
      this.needs_credentials = false
      try {
        const response = await processEnrollment(this.form.token)
        console.log('Process response', response)

        if (response.action === 'enrolled') {
          this.enrollment = response.lti_enrollment
        } else if (response.action === 'credentials_required') {
          // New user - needs to complete enrollment via pay page
          this.enrollment = response.lti_enrollment
          this.needs_credentials = true
        }
      } catch (error) {
        // For admins, show both technical error and student message
        const technicalError = error.response?.data?.error?.message
        const errorCode = error.response?.data?.error?.code
        const studentMessage = this.getStudentMessage(errorCode)

        if (technicalError) {
          this.process_errors.push(`Technical: ${technicalError}`)
          if (studentMessage) {
            this.process_errors.push(`Student sees: ${studentMessage}`)
          }
        } else {
          this.process_errors.push(error.response?.status === 404 ? "Not found" : "An error occurred")
        }
        console.log(error)
      }
      this.isProcessing = false
    },
    getStudentMessage(errorCode) {
      return ERROR_MESSAGES[errorCode] || null
    },
    async processMembership() {
      this.isProcessing = true
      this.membership_errors = []
      try {
        this.membership = await processMembership(this.form.token)
        console.log('Membership', this.membership)
      } catch (error) {
        // For admins, show both technical error and student message
        const technicalError = error.response?.data?.error?.message
        const errorCode = error.response?.data?.error?.code
        const studentMessage = this.getStudentMessage(errorCode)

        if (technicalError) {
          this.membership_errors.push(`Technical: ${technicalError}`)
          if (studentMessage) {
            this.membership_errors.push(`Student sees: ${studentMessage}`)
          }
        } else {
          this.membership_errors.push(error.response?.status === 404 ? "Not found" : "An error occurred")
        }

        // Update membership state if provided (422 errors)
        if (error.response?.data?.membership) {
          this.membership = error.response.data.membership
        }

        console.log(error)
      }
      this.isProcessing = false
    },

    async unProcessEnrollment() {
      this.isProcessing = true
      this.token_errors = []
      try {
        this.enrollment = await unProcessEnrollment(this.form.token)
        console.log('Enrollment', this.enrollment)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.token_errors.push("Not found")
        } else if (error.response && error.response.status === 500) {
          this.token_errors.push("Internal Server Error")
        } else {
          if (error.response?.data?.error) this.token_errors.push(error.response.data.error)
          if (error.response?.data?.errors) this.token_errors.push(error.response.data.errors)
          if (!error.response) this.token_errors.push("Network error")
          console.log(error)
        }
      }
      this.isProcessing = false
    },
    async unProcessMembership() {
      this.isProcessing = true
      this.token_errors = []
      try {
        this.membership = await unProcessMembership(this.form.token)
        console.log('Membership', this.membership)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.token_errors.push("Not found")
        } else if (error.response && error.response.status === 500) {
          this.token_errors.push("Internal Server Error")
        } else {
          if (error.response?.data?.error) this.token_errors.push(error.response.data.error)
          if (error.response?.data?.errors) this.token_errors.push(error.response.data.errors)
          if (!error.response) this.token_errors.push("Network error")
          console.log(error)
        }
      }
      this.isProcessing = false
    }

  }
}
</script>